export enum Profile {
  AGENT = 'agent',
  HEADQUARTER = 'headquarter'
}
